<template>
  <div class="wrapper">
    <div id="mps">
      <div id="videoPlayer" class="videoPlayer">
        <div style="display: none"><video></video></div>
      </div>
    </div>
    <div class="mobile-num">
      <num-watch v-if="channelInfo.isDisplayWatchNum === 1"></num-watch>
    </div>
    <div class="menu-right">
      <menu-right :mps="mpsPlayerObj"></menu-right>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import { cloneDeep } from 'lodash'
import numWatch from "./numWatch";
import menuRight from "./menuRight";
import { ENV_CONFIG } from '@/config';

export default {
  name: 'PlayerBox',
  components: {
    numWatch,
    menuRight,
  },
  data() {
    return {
      mpsPlayerObj: null, // 播放器实例
      onePlayer: true, // 切换自动播放问题
      isPlayerReady: false, // 播放器是否初始化完成
      retryTimes: 0, // 更新播放器播放地址重试次数
      retryTimesLimit: 5, // 更新播放器播放地址重试次数限制
      isElementOnReady: false, // 播放器元素是否准备完成
    };
  },
  computed: {
    ...mapGetters({
      uuid: 'uuid',
      channelInfo: "channelInfo",
      playerInfo: "playerInfo",
      playerAddress: "playerAddress",
    }),
    // 直播状态
    liveStatus() {
      return this.channelInfo.liveStatus
    },
    // 是否是VR直播
    isVR() {
      return !!this.channelInfo.isVr
    },
    // 播放器背景图
    mpsBackgroundUrl() {
      let bgUrl = this.channelInfo.mpsBackgroundUrl;
      return bgUrl
        ? `${bgUrl}${
            ENV_CONFIG.IS_PRIVATE ? '' : '?x-oss-process=image/resize,m_fixed,w_1280,h_720'
          }`
        : ''
    },
    // 初始播放地址
    playerUrl() {
      let playUrl = this.playerAddress
      let saveUrl = this.playerAddress
      return {
        playUrl,
        saveUrl,
      }
    },
    isReadyToInitPlayer() {
      if (this.isVR) {
        return this.playerInfo.playUrl && this.isElementOnReady
      }
      // dom 完成后立即初始化播放器
      return this.isElementOnReady
    },
  },
  watch: {
    uuid: {
      handler(val) {
        if (val) {
          // 心跳连接完成后，开始获取播放地址
          this.get_playAddress()
        }
      },
      immediate: true,
    },
    // 将初始化后的直播或点播地址 放入store中并备份
    playerUrl: {
      handler(newVal) {
        const { playUrl, saveUrl } = newVal
        /* 当点播切换到直播时，如果直播地址过快被切换，则播放器会黑屏，此处处理为了修复播放器重试机制异常的bug，故增加10秒的时间 */
        if (this.liveStatus === 1 && this.isPlayerReady) {
          setTimeout(() => {
            this.set_playerInfo(
              cloneDeep({
                playUrl,
                saveUrl,
                cameraId: '',
              })
            )
          }, 10000)
        } else {
          this.set_playerInfo(
            cloneDeep({
              playUrl,
              saveUrl,
              cameraId: '',
            })
          )
        }
      },
      immediate: true,
      deep: true,
    },
    // 取出store中的地址进行播放（saveUrl一定是初始地址，playUrl地址可能是初始化地址也可能是播单或主子机位地址）
    playerInfo: {
      handler({ playUrl }) {
        if (playUrl) {
          this.retryUpdatePlayUrl(playUrl)
        }
      },
      deep: true,
    },
    isReadyToInitPlayer: {
      handler(val) {
        if (val) {
          this.mpsPlayerInit()
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.isElementOnReady = true
  },
  methods: {
    ...mapActions({
      get_playAddress: 'get_playAddress',
    }),
    ...mapMutations({
      set_playerInfo: "set_playerInfo",
    }),
    mpsPlayerInit() {
      const self = this;
      if (this.mpsPlayerObj) {
        return false;
      }
      const playerOpts = {
        container: "videoPlayer",
        uin: this.channelInfo.aodianUin,
        appId: this.channelInfo.mpsDynamicVodAppId,
        width: "100%",
        height: "100%",
        controlbardisplay: "enable",
        enablehtml5: true,
        coverImg: this.mpsBackgroundUrl,
        type: this.isVR ? 'vr' : '',
        onReady() {
          self.isPlayerReady = true
          setTimeout(() => {
            //  1 2 3  默认最后一帧  封面图 自定义图片  循环播放
            self.mpsPlayerObj.addPlayerCallback("Play.Stop", function (fn) {
              fn({ type: 3 });
            });
          }, 2000);
        },
      };
      if (this.isVR) {
        // vr模式播放器是video.js封装，播放器初始化会预检地址合法性，因此需要先设置，另外vr模式下调用changePlayer会自动开始播放视频流
        playerOpts.url = this.playerInfo.playUrl
      }
      // eslint-disable-next-line no-undef, new-cap
      this.mpsPlayerObj = new mpsPlayer(playerOpts);
    },
    reviseProtocol(url) {
      let path = url
      if (!path) {
        return ''
      }
      if (window.location.protocol === 'http:') {
        path = path.replace('https://', 'http://')
      } else {
        path = path.replace('http://', 'https://')
      }
      return path
    },
    mpsPlayerUpdate(url) {
      const newPlayUrl = this.reviseProtocol(url)
      if (!this.mpsPlayerObj) {
        return
      }
      if (this.mpsPlayerObj && this.mpsPlayerObj.changePlayer) {
        if (this.onePlayer) {
          this.mpsPlayerObj.changePlayer(newPlayUrl, this.isVR)
          this.onePlayer = false
        } else {
          this.mpsPlayerObj.changePlayer(newPlayUrl)
        }
      }
    },
    retryUpdatePlayUrl(url) {
      if (!this.mpsPlayerObj) {
        this.mpsPlayerInit()
        return
      }
      if (this.isPlayerReady) {
        this.mpsPlayerUpdate(url)
        this.retryTimes = 0
      } else {
        if (this.retryTimes <= this.retryTimesLimit) {
          setTimeout(() => {
            this.retryUpdatePlayUrl(url)
          }, 1000)
        }
        this.retryTimes++
      }
    },
  },
};
</script>
<style lang="less" scoped>
.wrapper {
  position: relative;
  height: 100%;
  overflow: hidden;
  background-color: #000;
}
#mps {
  height: 100%;
  .videoPlayer {
    position: relative;
    z-index: 100;
    width: 100%;
    height: 100%;
  }
}
.mobile-num {
  position: absolute;
  right: 10px;
  top: 25px;
  z-index: 110;
}
.menu-right {
  position: absolute;
  right: -100% - 10px;
  top: 50%;
  z-index: 110;
  width: 50px;
  color: #fff;
  transform: translateY(-50%);
  transition: right 0.5s ease 3s;
}
.wrapper:hover {
  .menu-right {
    right: 10px;
    transition: right 0.5s ease 0s;
  }
}
</style>
<style>
#videoBox {
  width: 100% !important;
  height: 100% !important;
}
</style>
